// Turns a literal `<br>` in an answer into a real line break, and nothing else.
//
// Models write `<br>` inside Markdown table cells, where Markdown has no line-break syntax of its
// own. The chat renders Markdown without raw HTML, so that tag reached the person as the literal
// text "<br>". This converts exactly one tag, in its three spellings and with no attributes, into
// Markdown's own `break` node; every other tag is still escaped. It is the one exception to raw HTML
// staying text (@adr SPARK-0061-markdown-renders-raw-html-escaped@1), and only AgentMarkdown runs it.

interface MdNode {
  type: string;
  value?: string;
  children?: MdNode[];
}

const BR = /^<br\s*\/?>$/i;

function walk(node: MdNode): void {
  if (!node.children) return;
  node.children = node.children.map((child) =>
    child.type === "html" && BR.test((child.value ?? "").trim()) ? { type: "break" } : child,
  );
  for (const child of node.children) walk(child);
}

/** remark plugin: `<br>` / `<br/>` / `<br />` become line breaks, inside table cells included. */
export function remarkHtmlBreaks() {
  return (tree: MdNode) => walk(tree);
}
